import React from 'react';
import { Skeleton, SkeletonSquare } from '@fiverr-private/feedback';
import { Stack, Wrap } from '@fiverr-private/layout_components';

const ImportLoading = () => {
    const skeletonCard = (index: number) => (
        <Stack paddingY="3" paddingX="4" gap="5" borderRadius="sm" borderWidth="sm" width="100%" key={index}>
            <SkeletonSquare height={48} width={48} />
            <Wrap direction="column">
                <Stack gap="4" direction="column">
                    <SkeletonSquare height={24} width={216} />
                    <Stack gap="2" direction="column">
                        <SkeletonSquare height={16} width={160} />
                        <SkeletonSquare height={16} width={120} />
                    </Stack>
                </Stack>
            </Wrap>
        </Stack>
    );
    return (
        <Skeleton width="auto" dataTestId="import-loading">
            <Stack gap="8" direction="column" width="100%">
                <SkeletonSquare height={32} width={196} />
                {[...Array(3)].map((_, index) => skeletonCard(index))}
            </Stack>
        </Skeleton>
    );
};

export default ImportLoading;
